<template>
  <div class="ckeditor">
    <textarea
      :id="id"
      :value="value"
      :name="name"
    />
  </div>
</template>

<script>
  const CKEDITOR = window.CKEDITOR;
  let index = 0;

  if (!CKEDITOR) {
    throw new Error('[VueCkeditor] cannot locate CKEDITOR.');
  }

  export default {
    name: 'VueCkeditor',
    props: {
      value: {
        type: String
      },
      id: {
        type: String,
        default: () => `editor-${index += 1}`
      },
      name: {
        type: String,
      },
    },

    data() {
      return {
        count: 0
      }
    },

    beforeUpdate() {
      const { id } = this;

      if (this.value !== CKEDITOR.instances[id].getData()) {
        CKEDITOR.instances[id].setData(this.value);
      }
    },

    mounted() {
      const { id } = this;

      CKEDITOR.replace(id, {});
      CKEDITOR.instances[id].setData(this.value);
      CKEDITOR.instances[id].on('change', () => {
        const value = CKEDITOR.instances[id].getData();

        if (value !== this.value) {
          this.$emit('input', value);
        }
      });
    },

    beforeDestroy() {
      const { id } = this;

      if (CKEDITOR.instances[id]) {
        CKEDITOR.instances[id].destroy();
      }
    },
  }
</script>
